import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLocations } from "@/lib/hooks";
import { useI18n } from "@/i18n/I18n";

export const LocationSelect = ({ value, onChange, testId = "location-select" }) => {
  const { t } = useI18n();
  const { data: locs = [] } = useLocations();
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? null : v)}>
      <SelectTrigger data-testid={testId} className="h-12 font-mono text-xs"><SelectValue /></SelectTrigger>
      <SelectContent className="max-h-80">
        <SelectItem value="none">{t("common.noLocation")}</SelectItem>
        {locs.map((l) => (
          <SelectItem key={l.id} value={l.id} className="font-mono text-xs" data-testid={`location-option-${l.id}`}>
            {l.path.map((p) => p.name).join(" → ")}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const CategorySelect = ({ value, onChange, cats, label, testId = "category-select" }) => {
  const { t } = useI18n();
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? null : v)}>
      <SelectTrigger data-testid={testId} className="h-12"><SelectValue /></SelectTrigger>
      <SelectContent className="max-h-80">
        <SelectItem value="none">{t("common.none")}</SelectItem>
        {cats.map((c) => <SelectItem key={c.id} value={c.id}>{label(c)}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
